import { UserContext } from 'core/contexts/UserContext'
import { PromptSubHeader } from 'lauria/components/prompts/PromptSubHeader'
import { PromptSubHeaderMobile } from 'lauria/components/prompts/PromptSubHeaderMobile'
import { promptLayout } from 'lauria/store/slices/promptLayout'
import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router'

export const Prompts = () => {
  const { application } = useSelector(promptLayout)

  const { user } = useContext(UserContext)
  const canEditPrompts =
    user?.superAdmin ||
    application?.responsables.some(
      (responsable) => responsable.id === user?.idUtilisateur
    ) ||
    false

  if (!application) {
    return null
  }
  return (
    <div className="prompt-page">
      <PromptSubHeader
        application={application}
        canEditPrompts={canEditPrompts}
      />
      {canEditPrompts && <PromptSubHeaderMobile application={application} />}
      <div className="prompt-content">
        <Outlet />
      </div>
    </div>
  )
}
